import config from '@/config';

export default function ArtistImage({ image, imageClassName }) {
  return (
    <img
      srcSet={
        `${config.app.imageServiceDomain}/${image}/w=200 200w,
           ${config.app.imageServiceDomain}/${image}/w=400 400w,
           ${config.app.imageServiceDomain}/${image}/w=600 600w,
           ${config.app.imageServiceDomain}/${image}/w=800 800w,
           ${config.app.imageServiceDomain}/${image}/w=1000 1000w,
           ${config.app.imageServiceDomain}/${image}/w=1200 1200w,
           ${config.app.imageServiceDomain}/${image}/w=1400 1400w,
           ${config.app.imageServiceDomain}/${image}/w=1600 1600w,
           ${config.app.imageServiceDomain}/${image}/w=1800 1800w,
           ${config.app.imageServiceDomain}/${image}/w=2000 2000w,
           ${config.app.imageServiceDomain}/${image}/w=2200 2200w`
      }
      alt={"Artist Image"}
      className={imageClassName}
    />
  );
}
